import { render, staticRenderFns } from "./ZoneColorDialogComponent.vue?vue&type=template&id=3415d99c&scoped=true"
import script from "./ZoneColorDialogComponent.js?vue&type=script&lang=js&external"
export * from "./ZoneColorDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./ZoneColorDialogComponent.vue?vue&type=style&index=0&id=3415d99c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3415d99c",
  null
  
)

export default component.exports